// Ship Gate 2b — reusable Tax Year badge.
// Use on every report/page that's filtered by tax year so users always know
// which year they're viewing (TurboTax-style mental model).
import { Calendar } from "lucide-react";
import { useTaxYear } from "../contexts/TaxYearContext";

export default function TaxYearBadge({ label = "Tax Year", className = "" }) {
  const { taxYear, currentCalendarYear } = useTaxYear();
  const isPast = taxYear < currentCalendarYear;
  return (
    <span
      data-testid="tax-year-badge"
      className={`inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold rounded px-2 py-1 ${
        isPast ? "bg-amber-100 text-amber-800 border border-amber-200" : "bg-purple-100 text-purple-800 border border-purple-200"
      } ${className}`}
      style={{ fontFamily: "Manrope" }}
      title={isPast ? "Past tax year (read-only after subscription end)" : "Current tax year"}
    >
      <Calendar className="w-3 h-3" />
      {label}: {taxYear}
    </span>
  );
}

// Variant for CACFP pages — labels with CACFP fiscal year
export function FiscalYearBadge({ fy, mode = "calendar", className = "" }) {
  if (!fy) return null;
  const label = mode === "usda_fy" ? `USDA FY ${fy}` : `FY ${fy}`;
  const sub = mode === "usda_fy" ? `Oct ${fy - 1} – Sept ${fy}` : `Jan – Dec ${fy}`;
  return (
    <span
      data-testid="fiscal-year-badge"
      className={`inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold rounded px-2 py-1 bg-emerald-100 text-emerald-800 border border-emerald-200 ${className}`}
      style={{ fontFamily: "Manrope" }}
      title={sub}
    >
      <Calendar className="w-3 h-3" />
      {label} <span className="font-normal normal-case opacity-70">— {sub}</span>
    </span>
  );
}
